import { getSOCReportDownload } from './API';
import { extractApiErrorMessage } from 'src/utils/apiErrorUtils';

const GetSOCReportFile = async (fileName, accessToken) => {
  try {
    const response = await getSOCReportDownload(fileName, accessToken);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, data: extractApiErrorMessage(error) };
  }
};

export default GetSOCReportFile;